import each from 'lodash/each'

const isInteger = (val) => {
  const v = String(val)
  // Could use regex, but for sake of pure speed...
  return v === '0'
    || v === '1'
    || v === '2'
    || v === '3'
    || v === '4'
    || v === '5'
    || v === '6'
    || v === '7'
    || v === '8'
    || v === '9'
}

const isOther = (val) => /^[^A-Za-z0-9\u0080-\uFFFF]$/.test(val)

function setupListNav(listEl) {
  const listItems = listEl.querySelectorAll(':scope > li')
  if (!listItems.length) {
    return
  }

  let countMap = new Map()
  listItems.forEach((itemEl) => {
    const firstChar = itemEl.textContent.trim().substring(0, 1).toUpperCase()
    if (isInteger(firstChar)) {
      itemEl.dataset.firstChar = '0'
      countMap.set('0', (countMap.get('0') || 0) + 1)
    } else if (isOther(firstChar)) {
      itemEl.dataset.firstChar = '-'
      countMap.set('-', (countMap.get('-') || 0) + 1)
    } else {
      itemEl.dataset.firstChar = firstChar
      countMap.set(firstChar, (countMap.get(firstChar) || 0) + 1)
    }
  })
  countMap = new Map([...countMap].sort((a, b) => String(a[0]).localeCompare(b[0])))

  const nav = document.createElement('ul')
  nav.classList.add('list-nav')
  const selectedClassName = 'is-selected'
  const hiddenClassName = 'is-hidden'

  const activateChar = (char) => {
    nav.querySelectorAll('button').forEach((button) => {
      if (button.dataset.char === String(char)) {
        button.classList.add(selectedClassName)
      } else {
        button.classList.remove(selectedClassName)
      }
    })

    // All:
    if (char === '~') {
      listItems.forEach((itemEl) => {
        itemEl.classList.remove(hiddenClassName)
      })
      return
    }

    listItems.forEach((itemEl) => {
      const { firstChar } = itemEl.dataset
      if (char === firstChar) {
        itemEl.classList.remove(hiddenClassName)
      } else {
        itemEl.classList.add(hiddenClassName)
      }
    })
  }

  const generateListItem = (label, char, charCount, isActive) => {
    const button = document.createElement('button')
    if (isActive) {
      button.classList.add('is-selected')
    }
    button.classList.add('list-nav__button')
    button.type = 'button'
    button.textContent = label
    button.dataset.char = char
    button.setAttribute('data-count', charCount) // needed by CSS
    button.addEventListener('click', () => {
      activateChar(char)
    })
    const listItem = document.createElement('li')
    listItem.classList.add('list-nav__item')
    listItem.appendChild(button)
    return listItem
  }

  nav.appendChild(generateListItem('All', '~', listItems.length, true))
  countMap.forEach((charCount, char) => {
    let label
    switch (char) {
      case '0':
        label = '0-9'
        break
      case '-':
        label = '...'
        break
      default:
        label = char
    }
    const listItem = generateListItem(label, char, charCount)
    nav.appendChild(listItem)
  })

  listEl.parentNode.insertBefore(nav, listEl)
}

/**
 * @param {HTMLElement} container
 */
function setupListNavs(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll('ol.with-listnav, ul.with-listnav')
  if (existingEls.length) {
    each(existingEls, (el) => {
      setupListNav(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll('ol.with-listnav, ul.with-listnav')
        if (!els.length) {
          return
        }

        each(els, (el) => {
          setupListNav(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

// eslint-disable-next-line import/prefer-default-export
export { setupListNavs, setupListNav }
